import { getAllIconsByCompanyId, addIconsToLocal, fetchSvgContentFromS3 } from '@/repo/iconsRepo';
import WhiteLabelConfig from '../../src/config/app';
import { clearDB } from '@/repo/appSettingRepo.js';
import { setApplicationSetup } from '@/repo/appSettingRepo';
import store from '@/store';
export async function setUpApplication() {
  try {
    let currentWorkspace = store.getters['auth/getAuthenticatedUser'].current_workspace;
    const applicationSettings = WhiteLabelConfig;
    await clearDB(true);
    let promises = [
      store.dispatch('settings/fetchApplicationSettings'),
      store.dispatch('auth/getPermissions'),
      fetchUserData(),
      store.dispatch('company/fetchCompany', currentWorkspace.company_id),
      store.dispatch('company/fetchCompanyLogo', currentWorkspace.company_id),
      store.dispatch('globalVariables/fetchGlobalVariableTypes'),
      store.dispatch('auth/fetchProfile'),
      store.dispatch('paymentGateway/fetchSubscriptionInfo', {
        email: 'info@esigns.io',
      }),
      store.dispatch('icons/fetchApiIcons'),
    ];
    if (applicationSettings?.APP_MODE == 'APP') {
      promises.push(setApplicationSetup());
      store.commit('auth/setAppMode', true, {
        root: true,
      });
    } else {
      promises.push(loadCompanyIcons(currentWorkspace));
    }
    if (currentWorkspace.plan_type != 'INDIVIDUAL' && currentWorkspace.user_type) {
      promises.push(getCompanyUserType());
    }
    await Promise.all(promises);
  } catch (error) {
    console.error('failed to setup application details', error);
    throw error;
  }
}
export async function fetchUserData() {
  try {
    let currentWorkspace = store.getters['auth/getAuthenticatedUser'].current_workspace;
    await store.dispatch(
      'auth/fetchUsersWithEmail',
      store.getters['auth/getAuthenticatedUser'].email
    );
    if (store.getters['auth/getWorkspaceList']) {
      let userWorkspaceList = store.getters['auth/getWorkspaceList'] || [];
      let hasIndividual = store.getters['auth/getAuthenticatedUser'].workspace.findIndex(
        (u) => u.plan_type == 'INDIVIDUAL'
      );
      if (hasIndividual != -1) {
        let individualWorkspace = {};
        if (store.getters['auth/getAuthenticatedUser'].workspace[hasIndividual].company_id) {
          this.$set(
            individualWorkspace,
            '_id',
            '' + store.getters['auth/getAuthenticatedUser'].workspace[hasIndividual].company_id
          );
        } else {
          this.$set(individualWorkspace, '_id', '0');
        }
        this.$set(individualWorkspace, 'name', 'INDIVIDUAL');
        userWorkspaceList[hasIndividual]['company_id'] = individualWorkspace;
        if (currentWorkspace.plan_type == 'INDIVIDUAL') {
          if (store.getters['auth/getAuthenticatedUser'].workspace[hasIndividual].company_id) {
            currentWorkspace['company_id'] =
              '' + store.getters['auth/getAuthenticatedUser'].workspace[hasIndividual].company_id;
          } else {
            currentWorkspace['company_id'] = '0';
          }
        }
      }
      store.commit('auth/setActiveWorkspace', currentWorkspace, {
        root: true,
      });
      store.commit('auth/setWorkspaceList', userWorkspaceList, {
        root: true,
      });
    }
  } catch (error) {
    console.error('failed to get user data', error);
    throw error;
  }
}
export async function loadCompanyIcons(currentWorkspace) {
  const companyId = currentWorkspace.company_id;
  try {
    const result = await getAllIconsByCompanyId(companyId);
    const iconGroups = result?.data || [];
    const normalizedSet = new Set();
    iconGroups.forEach((group) => {
      group.value.forEach((key) => {
        const actualKey = key
          .toLowerCase()
          .replace(/\.svg$/, '')
          .replace(/\s+/g, '-');
        normalizedSet.add(actualKey);
      });
    });
    const iconKeys = Array.from(normalizedSet);
    const svgIcons = await fetchSvgContentFromS3(iconKeys);
    const apiIcons = store.getters['icons/getApiIcons'];
    const enrichedIcons = apiIcons.map((icon) => {
      const matched = svgIcons.find((svg) => svg.key === icon.key);
      return {
        ...icon,
        content: matched?.content,
      };
    });
    const iconsWithContent = enrichedIcons.filter((icon) => !!icon.content);
    await addIconsToLocal(iconsWithContent);
  } catch (error) {
    console.error('Error loading and caching company icons:', error);
  }
}
export async function getCompanyUserType() {
  try {
    let currentWorkspace = store.getters['auth/getAuthenticatedUser'].current_workspace;
    await store.dispatch('auth/getUserTypeById', currentWorkspace.user_type);
  } catch (err) {
    console.error('dome');
    throw err;
  }
}
export async function loginUserInfo(data) {
  try {
    let tokens = {
      access_token: data.access_token,
      refresh_token: data.refresh_token,
      refresh_token_expires_at: data.refresh_token_expires_at,
      access_token_expires_at: data.access_token_expires_at,
    };
    store.commit('auth/setMf2a', false, { root: true });
    store.commit('auth/setAuthenticatedUser', data.user_details, {
      root: true,
    });
    store.commit('auth/setAuthenticationDetails', tokens, {
      root: true,
    });
    store.commit('auth/setAuthenticationStatus', true, {
      root: true,
    });
    store.commit('auth/setErrorCode', '', {
      root: true,
    });
    store.commit('auth/setErrorData', '', {
      root: true,
    });
    store.commit('auth/setloginTimeStamp', new Date(), {
      root: true,
    });
  } catch (err) {
    console.error('loginUserInfo failed:', err);
    throw err;
  }
}
